<template>
  <div class="home flex-fill mt-3 mb-3">
    <Layout :chartData="chartData" :chartLabels="chartLabels" :mapData="mapData" :totalData="totalData" />
  </div>
</template>

<script>
// @ is an alias to /src
import Layout from '@/components/Layout.vue'

export default {
  name: 'Home',
  props: {
    chartData: Object,
    chartLabels: Object,
    mapData: Object,
    totalData: Object
  },
  components: {
    Layout
  }
}
</script>
